/**
 * Takes a list and an optional reference and returns an hyphenated
 * format of the contiguous values in the array.
 * The integrity of the contents in the array are maintained.
 *
 * The list could have Numerical or String Values
 * E.g: [0, 1, 3, 5, 6, 7, 8, 18, 10, 19, 30, 31] ===> [0 - 1, 3, 5 - 8, 10, 18 - 19, 30 - 31]
 *      ["Monday", "Tuesday", "Wednesday"]        ===> ["Monday - Wednesday"]
 *
 * @param {Array<number,string>}  aList : Values to be formatted.
 * @param {Array<string>} reference     : Reference point for formatting. Typically a list of
 *                                        contiguous values.
 *
 * @return {Array<string>}
 */

export default (aList, reference) => {
  const ascending = (a, b) => a - b;
  let temp = [];
  const result = [];
  let finalOutput = [];

  if (!reference && typeof aList[0] === "number") {
    aList.sort(ascending);
    for (let i = 0; i < aList.length; i++) {
      temp.push(aList[i]);
      if (i >= aList.length || aList[i + 1] - aList[i] !== 1) {
        if (temp.length === 1) result.push(`${temp[0]}`);
        else result.push(`${temp[0]} - ${temp[temp.length - 1]}`);
        temp = [];
      }
    }
    finalOutput = result;
  } else {
    for (let i = 0; i < aList.length; i++) {
      temp.push(aList[i]);

      const currentIndex = reference.indexOf(aList[i]);
      const nextIndex = reference.indexOf(aList[i + 1]);
      const isNotContiguous = nextIndex - currentIndex !== 1;
      const adjustment =
        reference.indexOf(aList[i + 1]) === 0 &&
        reference.indexOf(aList[i]) === reference.length - 1
          ? 1
          : -1;

      if (i >= aList.length || (isNotContiguous && adjustment !== 1)) {
        if (temp.length === 1) result.push(`${temp[0]}`);
        else result.push(`${temp[0]} - ${temp[temp.length - 1]}`);
        temp = [];
      }
    }
    finalOutput = result;
  }

  return finalOutput;
};
